import i18n, { Resource } from "i18next";
import { initReactI18next } from "react-i18next";
import en from "@/i18n/en/translation.json";

const resources: Resource = { en: { translation: en } };

i18n.use(initReactI18next).init({
  lng: "en",
  fallbackLng: "en",
  resources,
  interpolation: { escapeValue: false },
});

export default i18n;

// Enable HMR when translation config changes, avoiding a hard page refresh
if (import.meta.hot) {
  import.meta.hot.accept("@/i18n/en/translation.json", (mod) => {
    if (!mod) return;
    i18n.addResourceBundle("en", "translation", mod.default, true, true);
    i18n.changeLanguage(i18n.language);
  });
}
